import React from 'react';
import classNames from 'classnames';

import emailValidator from './validator';
import TextField from '../../stateless/textField';
import { noop } from 'helpers';

class EmailField extends React.PureComponent {

  static defaultProps = {
    errorKey: 'email',
    setErrors: noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      value: '',
    };
  }

  validate = (emptyErrors = false) => {
    const { value } = this.props;
    const showError = emptyErrors ? false : !emailValidator(value);
    this.setState({ showError });
    this.props.setErrors(showError, this.props.errorKey);
  };

  setFocusedEmailState = mode => {
    this.setState({ isFocused: mode });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.validate(!this.props.value);
    }
  };

  render() {
    const labelClassNames = classNames('label-holder', { 'error': this.state.showError });
    const { value } = this.state;
    const { errorMessage, errorKey, setErrors, description, ...rest } = this.props;

    return (
      <label className={labelClassNames}>
        <div className="label-title has-description">
          <span>E-mail</span>
          {description && (
            <div className="description-holder">
              <i className="icon icon-question-mark" />
              <div className="description-tooltip">
                {description}
              </div>
            </div>
          )}
        </div>
        <div className="input-holder">
          <div className="left-icon icon-envelope" />
          <TextField
            onBlur={() => this.setFocusedEmailState(false)}
            value={value}
            { ...rest }
          />
        </div>
        {(this.state.showError || errorMessage) && (
          <div className="error-text-wrapper">
            {
              (this.state.showError && 'Email is not valid') || (errorMessage && <div>{errorMessage}</div>)
            }
          </div>
        )}
      </label>
    );
  }
};

export default EmailField;
